import { combineReducers } from "redux";
import common from "./reducers/common";
import auth from "./reducers/auth";
import client from "./reducers/client";
import clients from "./reducers/clients";
import users from "./reducers/users";
import { reducer as formReducer } from "redux-form";

export default combineReducers({
    common,
    auth,
    clients,
    client,
    users,
    form: formReducer,
});



// WEBPACK FOOTER //
// ./src/reducer.js